import React from 'react';
import { Logo } from '../../ResultView/ResultList/ProfileCards/search-card/Logo/Logo';
import { FeaturedTag } from '../../ResultView/ResultList/ProfileCards/search-card/PracticeCard/FeaturedTag/FeaturedTag';
import { ProfileName } from '../../ResultView/ResultList/ProfileCards/search-card/ProfileName/ProfileName';
import { Card, CardBody } from '../../ResultView/ResultList/ProfileCards/search-card/card.styles';
import { SearchCardBody, CardChop, LeftCardChop } from './InlineAd.styles';
import { SearchAction, Props as SearchActionProps } from './SearchAction';

export interface InlineAdProps extends SearchActionProps {
  profileName: string;
  profileBody: string;
  logo: string;
  featured?: boolean;
}

export const InlineAd = ({
  profileName,
  profileBody,
  logo,
  label,
  nextUrl,
  clickTracking,
  featured = false,
}: InlineAdProps) => {
  const image = <Logo image={logo} />;

  const logoNode = featured ? <FeaturedTag>{image}</FeaturedTag> : image;

  return (
    <Card>
      <CardBody>
        <CardChop>
          <LeftCardChop>
            <ProfileName href={nextUrl ?? ''} trackingData={clickTracking}>
              {profileName}
            </ProfileName>
            <SearchCardBody>{profileBody}</SearchCardBody>
          </LeftCardChop>
          <div>{logoNode}</div>
        </CardChop>
      </CardBody>
      <SearchAction
        clickTracking={clickTracking}
        nextUrl={nextUrl}
        ctaText="Find out more"
        label={label}
      />
    </Card>
  );
};
